<div
  id="mobile-summary"
  class="flex flex-col items-center gap-2.5"
  [appPreventClickOnCondition]="shouldAllowClick"
  [class.disabled]="!shouldAllowClick()"
  [class.collapsed]="collapsed"
>
  <div class="hide-summary-button flex flex-row flex-wrap items-center gap-2.5">
    <div id="collapsable-section" class="flex w-full flex-col">
      <div class="flex w-full flex-row items-center justify-center gap-2">
        <div
          class="header flex flex-1 flex-row items-center justify-center gap-2.5"
          [class.collapsed]="collapsed"
          (click)="collapsed = !collapsed"
        >
          <div *ngIf="collapsed" class="barlow header-text flex flex-row items-center gap-2">
            <span>Mostrar información</span>
            <ion-icon icon="assets/icon/eye.svg"></ion-icon>
          </div>
          <div *ngIf="!collapsed" class="barlow header-text flex flex-row items-center gap-2">
            <span>Ocultar información</span>
            <ion-icon icon="assets/icon/covered-eye.svg"></ion-icon>
          </div>
        </div>
        <ion-button *ngIf="filesAlreadyAdded" (click)="addingFilesEvent()">
          <ion-icon icon="assets/icon/upload.svg"></ion-icon>
          Subir docs
        </ion-button>
      </div>
      <div
        id="collapsable-content"
        [class.collapsed]="collapsed"
        [class.filesAdded]="filesAlreadyAdded"
        class="flex w-full flex-col gap-1"
      >
        <!-- INFO DEL CARRITO -->
        <div>
          <div class="groupPrice flex flex-row items-baseline justify-between">
            <span class="groupPrice_label barlow">Esta carpeta</span>
            <span class="totalPrice_label barlow">Total del carrito</span>
          </div>
          <div class="totalPrice flex flex-row items-baseline justify-between">
            <span class="groupPrice_price league-spartan">{{
              this.printProduct.price.amt | currency: this.cartService.cart.price.cur : 'symbol' : '1.2-2'
            }}</span>
            <span class="totalPrice_price league-spartan">{{
              cartTotal | currency: this.cartService.cart.price.cur : 'symbol' : '1.2-2'
            }}</span>
          </div>
          <div class="shippingInfo flex flex-row items-center justify-end gap-1.5">
            <span>Envío estándar GRATIS a Península </span>
            <ion-icon [id]="'shippingInfo'" class="tooltip-icon" src="assets/icon/info.svg"></ion-icon>
            <ion-popover
              [trigger]="'shippingInfo'"
              class="info-popover"
              triggerAction="click"
              side="top"
              showBackdrop="true"
              animated="true"
            >
              <ng-template>
                <app-tooltip-info-shipping-free></app-tooltip-info-shipping-free>
              </ng-template>
            </ion-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="flex w-full flex-col gap-2.5">
      <!-- SLIDER DEL BOTON FINAL -->
      <div class="slider-container">
        <div class="slider-track"></div>
        <div #overlay id="overlay-layer"></div>
        <div class="slider-knob" #knob (touchstart)="startDragging($event)" (mousedown)="startDragging($event)">
          <ion-icon icon="assets/icon/carrito-arrow.svg"></ion-icon>
        </div>
        <div class="text-container flex flex-row items-center justify-center">
          <span class="slider-text">Arrastra para guardar e ir al carrito</span>
        </div>
      </div>
    </div>
  </div>
</div>
